module.exports = __webpack_public_path__ + "img/2024-07-01c_2.1a7b76ce.jpg";